module.exports = __webpack_public_path__ + "img/20.8e3df78f.svg";